import React from 'react';
import PropTypes from 'prop-types';
import { pluck, isNil } from 'ramda';

import DatePresenter from '../../../../../../presenters/DatePresenter';
import StorePresenter from '../../../../../../presenters/StorePresenter';
import { STATES } from '../../../../../../presenters/CashbackPresenter';
import Flash from '../../../../../../components/forms/Flash';
import StoreSelect from '../../../../../../components/StoreSelect';
import Row from '../../../../../../components/Row';
import Column from '../../../../../../components/Column';
import RangePicker from '../../../../../../components/RangePicker';

import StatesSelect from './components/StatesSelect';
import QuarantinedReasonsSelect from './components/QuarantinedReasonsSelect';

const Form = ({
  values,
  handleSubmit,
  setFieldValue,
  errors,
  stores,
  storesLoadingState,
}) => {
  const handleChange = ({ target: { id, value } }) => {
    setFieldValue(id, value);
  };

  const handleStartDateChange = (date) => {
    setFieldValue('afterDate', DatePresenter.shortFormattedDate(date));
  };
  const handleEndDateChange = (date) => {
    setFieldValue('beforeDate', DatePresenter.shortFormattedDate(date));
  };

  const handleSelectMultipleItems = (name, newValues) => {
    const newStates = isNil(newValues) ? [] : pluck('value', newValues);

    setFieldValue(name, newStates);
  };

  const isOnlyQuarantinedSelected =
    values.stateIn.length === 1 && values.stateIn.includes(STATES.quarantined);

  return (
    <form onSubmit={handleSubmit}>
      <div className="transactions-filters">
        <div className="form-header">
          <h4>Filters</h4>
          <div className="form-header-actions">
            <input
              id="findCashbacks"
              type="submit"
              value="Find"
              className="find-button"
            />
          </div>
        </div>
        <Flash response={errors} />
        <Row className="transactions-filters">
          <RangePicker
            startDate={values.afterDate}
            endDate={values.beforeDate}
            onStartDateChange={handleStartDateChange}
            onEndDateChange={handleEndDateChange}
          />
          <Column>
            <input
              type="text"
              id="byUser"
              placeholder="Auth0 id or email"
              value={values.byUser}
              onChange={handleChange}
              className="input-underlined"
            />
          </Column>
          <Column>
            <Column>
              <StoreSelect
                stores={stores}
                onChange={handleChange}
                value={values.storeIdEq}
                loadingState={storesLoadingState}
              />
            </Column>
          </Column>
        </Row>
        <Row>
          <Column>
            <StatesSelect
              values={values}
              onChange={handleSelectMultipleItems}
            />
          </Column>
          <Column>
            {isOnlyQuarantinedSelected && (
              <QuarantinedReasonsSelect
                values={values}
                onChange={handleSelectMultipleItems}
              />
            )}
          </Column>
        </Row>
      </div>
    </form>
  );
};

export default Form;

Form.propTypes = {
  values: PropTypes.shape().isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
  stores: PropTypes.arrayOf(StorePresenter.shape()).isRequired,
  storesLoadingState: PropTypes.string.isRequired,
};

Form.defaultProps = {
  errors: {},
};
